import { Component, inject } from '@angular/core';
import { BaseModalComponent } from "../base-modal/base-modal.component";
import { MatButton } from "@angular/material/button";
import { MatDivider } from "@angular/material/divider";
import { CommonModule } from "@angular/common";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AudienceParams, RecordData } from "../../../types/records-table.types";
import { getDefaultAudienceParams } from "../../../models/default-audience-params";
import { EditAudienceDialogData } from "./types/edit-audience-modal.types";
import { audienceResourceType } from './configs/edit-audience-modal-config';
import { AudienceAgeCardComponent } from "./components/audience-age-card/audience-age-card.component";
import { AudienceGeoCardComponent } from "./components/audience-geo-card/audience-geo-card.component";

@Component({
  selector: 'app-edit-audience-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    MatButton,
    MatDivider,
    CommonModule,
    AudienceAgeCardComponent,
    AudienceGeoCardComponent
  ],
  templateUrl: './edit-audience-modal.component.html',
  styleUrl: './edit-audience-modal.component.scss'
})
export class EditAudienceModalComponent extends BaseModalComponent {
  private dialogData = inject<EditAudienceDialogData>(MAT_DIALOG_DATA);

  public audienceParams: AudienceParams | null = null;
  public readonly audienceResourceType = audienceResourceType;

  public override async ngOnInit(): Promise<void> {
    this.modalStatesService.openModal(audienceResourceType.path);
    await this.initializeAudienceParams();
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(audienceResourceType.path);
  }

  public handleSaveButtonClick(): void {
    this.addNewRecord(audienceResourceType.path, this.audienceParams as unknown as RecordData)
      .then(() => this.closeDialog('success'));
  }

  private async initializeAudienceParams(): Promise<void> {
    if (!this.dialogData.audienceParamsId) {
      this.audienceParams = getDefaultAudienceParams();
      return;
    }

    await this.getAudienceData(this.dialogData.audienceParamsId);
  }

  private async getAudienceData(id: number): Promise<void> {
    this.audienceParams = await this.fetchRecordPropertyDataById<AudienceParams>({
      path: audienceResourceType.path,
      resourceId: +id
    }).catch(() => null);
  }
}
